export default {
    CASE_NUMBER: str =>
      // Adapted from https://pcl.uscourts.gov/js/validate.js,
      // ignoring leading and trailing spaces since our API gets rid of those
      // keep in sync with CourtAPI::Util::Untaint::as_case_no
      // this is the same regex as above, but with the \p{Pd} pattern replaced with the explicit character set
      /^(?:\d:)?(?:\d{2}|\d{4})(?:[\u002D\u058A\u05BE\u1400\u1806\u2010\u2011\u2012\u2013\u2014\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D][A-Za-z]{2}[\u002D\u058A\u05BE\u1400\u1806\u2010\u2011\u2012\u2013\u2014\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D]|\s[A-Za-z]{2}\s|[A-Za-z]{2}|[\u002D\u058A\u05BE\u1400\u1806\u2010\u2011\u2012\u2013\u2014\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D])\d{1,5}$/
        .test(str)
    ,
    CASE_NUMBER_WILDCARD: str =>
        // Case lookup form: validation: wildcard.
        /^\s*((\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+\*|(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+(\d{1,5})|(\d{1})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D \:]+(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]+(\d{1,5})|(\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*([\w\s]{1,2})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*(\d{1,5})|(\d{1})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D \:](\d{1,4})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*([\w\s]{1,2})[\-\u058A\u05BE\u2010-\u2015\u207B\u208B\u2212\u2E3A\u2E3B\uFE63\uFF0D ]*(\d{1,5}))(-[a-zA-Z]+)?\s*$/
            .test(str)
    ,
    SSN_OR_TIN: str =>
        // keep in sync with CGI::Untaint::ssntin
        /^\s*(\d{3}-\d{2}-\d{4}|\d{2}-\d{7}|\d{9})\s*$/
            .test(str)
    ,
    SSN4: str =>
        // keep in sync with CGI::Untaint::ssn4
        /^\s*(\d{4})\s*$/
            .test(str)
    ,
    PARTY_NAME_CASE_TITLE: str =>
        // keep in sync with CGI::Untaint::text
        /^\s*([a-z0-9\s\.&\*,'-]+?)\s*$/i
            .test(str)
    ,

};


// WEBPACK FOOTER //
// ./src/components/search/validations/index.js